'use client';

import React from 'react';

import MenuItem from './menu-item';
import { fetchDataFromBuilder, getBuilderCacheBusterKey } from 'src/scripts/utils/builder';
import { useCacheAndNetwork } from 'src/scripts/utils/react/useCacheAndNetwork';
import { DesktopNavMenu } from './NAV_TYPES';

function Menu() {
  // ! [REVISIT] for Sanath, add prefetch?
  // ? themeid as part of cacheKey?
  // ? similar to: `alo-theme-${themeInfo?.id}-apollo-cache-persist-navdata-${apolloCacheKeySegment}`,??
  const { data: L1Items } = useCacheAndNetwork('desktop-nav-data', getBuilderData, {
    // since DesktopNav above the fold & visible; we default more often to cache & the swap could be jarring
    // (cont) & as a multi-page app, they will see the update on next page load
    replaceStaleDataPostFetch: false,
    staleCacheTTL: 1000 * 60 * 60 * 6, // 6 hours, eta on builder downtime
  });

  return (
    <ul className="align-items-center main-nav__list" role="navigation">
      {L1Items?.map((link, index) => {
        return <MenuItem key={index} link={link} />;
      })}
    </ul>
  );
}

export default Menu;

const getBuilderData = () =>
  fetchDataFromBuilder<DesktopNavMenu>('desktop-navigation-menu', {
    options: { cb: getBuilderCacheBusterKey() },
  }).then((resp) => resp.data.items);
